import React, { Fragment } from "react";
import { Badge }  from "reactstrap";
import moment from 'moment';

import WinnerIcon from "~/assets/images/contest/winners.png"

import Contest from "~/services/contests";


const ContestCard = ({item})=> {

  const ranks = {
    1 : "FIRST PLACE",
    2 : "SECOND PLACE",
    3 : "THIRD PLACE",
    4 : "TOP 25",
    5 : "TOP 50"
  };

  const formatDate = (date)=> moment(date).format("YYYY-MM-DD");

  return (
    <Fragment>
      <img src={WinnerIcon} />

      <div className="item-details">
        <div>
          <h6>  {((item.type === 2 && item.frequency) > 1 ? "Monthly " : "Daily ") + Contest.titles[item.type]} </h6>
          <Badge color="points"> {"POINTS: " + item.reward} </Badge>
        </div>
        <div style={{textAlign: "right"}}>
          <h6> {formatDate(item.createdAt)} </h6>
          <Badge color="custom-completed"> {ranks[(item.type === 2 && item.rank > 3) ? (item.rank < 26 ? 4 : 5) : item.rank]} </Badge>
        </div>
      </div>
    </Fragment>
  );
};

export default ContestCard;
